import { render, staticRenderFns } from "./CompanyListClientCard.vue?vue&type=template&id=fbad809e&scoped=true"
import script from "./CompanyListClientCard.vue?vue&type=script&lang=js"
export * from "./CompanyListClientCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyListClientCard.vue?vue&type=style&index=0&id=fbad809e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbad809e",
  null
  
)

export default component.exports